/**
 * BV1 Admin sidebar — hard-coded 4-pillar navigation.
 * Must match client spec exactly. Do not auto-generate from routes.
 */
export const SIDEBAR_NAV = [
    {
        name: 'Overview',
        icon: 'LayoutDashboard',
        children: [
            { name: 'Executive Dashboard', path: '/analytics/overview', end: true },
        ],
    },
    {
        name: 'Finance',
        icon: 'Landmark',
        children: [
            { name: 'Dashboard', path: '/finance', end: true },
            { name: 'Sales', path: '/finance/sales' },
            { name: 'Expense', path: '/finance/expense' },
            { name: 'Expense Analytics', path: '/finance/expense-analytics' },
            { name: 'Commissions', path: '/finance/commissions' },
        ],
    },
    {
        name: 'Funnel',
        icon: 'GitBranch',
        children: [
            { name: 'Performance', path: '/funnel/performance' },
            { name: 'GHL Pipeline', path: '/funnel/ghl-pipeline' },
        ],
    },
    {
        name: 'Traffic & UTM',
        icon: 'Megaphone',
        children: [
            { name: 'Attribution', path: '/analytics/attribution' },
            { name: 'UTM Links', path: '/analytics/utm-links' },
        ],
    },
];

/** Footer link — separate from main pillar navigation. */
export const SIDEBAR_SETTINGS_LINK = {
    name: 'Settings',
    path: '/settings',
    icon: 'Settings',
};
